import { useRef } from 'react';
import classNames from 'classnames';
import I18n from 'i18n-js';

import { useTimer } from '@lootboy/lib/hooks';

import './style.css';

interface ILootCountdown {
  onEnd?: () => void;
  value: string;
}

export default function LootCountdown({
  onEnd,
  value,
}: ILootCountdown): JSX.Element {
  const { ended, days, hours, minutes, seconds } = useTimer(value, {
    normalize: true,
  });
  const onEndInvoked = useRef(false);

  // this way onEnd function can change between rerenders
  if (ended && onEnd && !onEndInvoked.current) {
    onEndInvoked.current = true;
    onEnd();
  }

  return (
    <div className={classNames('LootCountdown')}>
      <div className={classNames('cell')}>
        <p className={classNames('time')}>{days}</p>
        <p className={classNames('unit')}>{I18n.t('LootCountDownView_days')}</p>
      </div>
      <div className={classNames('cell')}>
        <p className={classNames('time')}>{hours}</p>
        <p className={classNames('unit')}>
          {I18n.t('LootCountDownView_hours')}
        </p>
      </div>
      <div className={classNames('cell')}>
        <p className={classNames('time')}>{minutes}</p>
        <p className={classNames('unit')}>
          {I18n.t('LootCountDownView_minutes')}
        </p>
      </div>
      <div className={classNames('cell')}>
        <p className={classNames('time')}>{seconds}</p>
        <p className={classNames('unit')}>
          {I18n.t('LootCountDownView_seconds')}
        </p>
      </div>
    </div>
  );
}
